import { render, staticRenderFns } from "./RequestW9ForSelfFillingModal.vue?vue&type=template&id=b54210dc&"
import script from "./RequestW9ForSelfFillingModal.vue?vue&type=script&lang=ts&"
export * from "./RequestW9ForSelfFillingModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports